module.exports = __webpack_public_path__ + "img/Invasion-NPC_GSE200310.e04b11f0.png";